import { render, staticRenderFns } from "./Section1.vue?vue&type=template&id=07599930&scoped=true"
import script from "./Section1.vue?vue&type=script&lang=js"
export * from "./Section1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07599930",
  null
  
)

export default component.exports